export default __webpack_public_path__ + "static/media/ArrowDown.3f943788.svg";